(() => {
  document.querySelectorAll('[data-dmpdp]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';

    let active = 0;
    const track = root.querySelector('[data-gallery-track]');
    const items = [...root.querySelectorAll('[data-gallery-item]')];
    const dots = [...root.querySelectorAll('[data-gallery-dot]')];
    const show = (index) => {
      if (!track || !items.length) return;
      active = (index + items.length) % items.length;
      track.style.transform = `translate3d(${-active * 100}%,0,0)`;
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        dot.setAttribute('aria-current', i === active ? 'true' : 'false');
      });
    };
    root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(active - 1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(active + 1));
    dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.galleryDot))));
    show(0);

    let touchX = 0;
    track?.addEventListener('touchstart', (event) => { touchX = event.touches[0].clientX; }, { passive: true });
    track?.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 45) show(active + (delta < 0 ? 1 : -1));
    }, { passive: true });

    root.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
      const controls = [...tabs.querySelectorAll('[data-product-tab]')];
      const panels = [...tabs.querySelectorAll('[data-product-panel]')];
      const activate = (index, focus = false) => {
        controls.forEach((control, i) => {
          const selected = i === index;
          control.setAttribute('aria-selected', selected ? 'true' : 'false');
          control.tabIndex = selected ? 0 : -1;
          if (selected && focus) control.focus();
        });
        panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          panel.classList.toggle('is-active', i === index);
        });
      };
      controls.forEach((control, index) => {
        control.addEventListener('click', () => activate(index));
        control.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? controls.length - 1 : index + (event.key === 'ArrowRight' ? 1 : -1);
          next = (next + controls.length) % controls.length;
          activate(next, true);
        });
      });
    });

    root.querySelectorAll('[data-master-form]').forEach((form) => {
      const quantity = form.querySelector('[data-qty-input]');
      const setQuantity = (value) => {
        if (!quantity) return;
        const minimum = Number(quantity.min || 1);
        const maximum = Number(quantity.max || 99);
        quantity.value = String(Math.min(maximum, Math.max(minimum, Number(value) || minimum)));
        quantity.dispatchEvent(new Event('change', { bubbles: true }));
      };
      form.querySelector('[data-qty-minus]')?.addEventListener('click', () => setQuantity(Number(quantity?.value || 1) - 1));
      form.querySelector('[data-qty-plus]')?.addEventListener('click', () => setQuantity(Number(quantity?.value || 1) + 1));

      const planInput = form.querySelector('[data-selling-plan-input]');
      const purchaseOptions = [...form.querySelectorAll('[data-purchase-option]')];
      purchaseOptions.forEach((option) => option.addEventListener('change', () => {
        purchaseOptions.forEach((item) => item.closest('label')?.classList.toggle('is-selected', item.checked));
        if (planInput) {
          const isPlan = Boolean(option.dataset.planId);
          planInput.disabled = !isPlan;
          planInput.name = isPlan ? 'selling_plan' : '';
          planInput.value = isPlan ? option.dataset.planId : '';
        }
        const price = option.dataset.planPrice || root.dataset.basePrice || '';
        root.querySelectorAll('[data-master-price],[data-master-atc-price]').forEach((el) => { el.textContent = price; });
      }));
    });

    root.querySelectorAll('[data-master-variant]').forEach((select) => select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      root.dataset.basePrice = option.dataset.price || '';
      root.querySelectorAll('[data-master-price],[data-master-atc-price]').forEach((el) => { el.textContent = option.dataset.price || ''; });
    }));

    root.querySelectorAll('[data-master-form]').forEach((form) => form.addEventListener('submit', () => {
      const addon = form.querySelector('[data-master-addon]:checked');
      if (!addon || form.querySelector('[data-master-bundle-field]')) return;
      const mainVariant = form.querySelector('[data-master-variant]') || form.querySelector('input[name="id"]');
      if (!mainVariant?.value) return;
      mainVariant.removeAttribute('name');
      const quantity = form.querySelector('input[name="quantity"]');
      const sellingPlan = form.querySelector('[data-selling-plan-input]:not([disabled])');
      quantity?.removeAttribute('name');
      sellingPlan?.removeAttribute('name');
      addon.name = 'items[1][id]';
      const fields = [
        ['items[0][id]', mainVariant.value],
        ['items[0][quantity]', quantity?.value || '1'],
        ['items[1][quantity]', '1']
      ];
      if (sellingPlan?.value) fields.push(['items[0][selling_plan]', sellingPlan.value]);
      fields.forEach(([name, value]) => {
        const field = document.createElement('input');
        field.type = 'hidden';
        field.name = name;
        field.value = value;
        field.dataset.masterBundleField = '';
        form.appendChild(field);
      });
    }));

    /* Le formulaire personnalisé est envoyé en AJAX puis ouvre exclusivement
       le drawer Démélé. Le cart drawer natif Shopify reste fermé. */
    root.querySelectorAll('[data-master-form],[data-master-upsell-form]').forEach((form) => {
      if (form.dataset.masterAjaxReady) return;
      form.dataset.masterAjaxReady = 'true';

      const demeleDrawerSelector = '[data-dmle-cart-drawer], .dmle-cart-drawer, .demele-cart-drawer, #DemeleCartDrawer';
      const getDemeleDrawer = () => document.querySelector(demeleDrawerSelector);
      const getDrawerSectionId = (drawer) => {
        if (!drawer) return '';
        const explicitId = drawer.getAttribute('data-section-id') || drawer.dataset.sectionId;
        if (explicitId) return explicitId;
        const section = drawer.closest('[id^="shopify-section-"]');
        return section?.id.replace('shopify-section-', '') || '';
      };
      const closeThemeDrawer = () => {
        document.querySelectorAll('cart-drawer:not([data-dmle-cart-drawer]):not(.demele-cart-drawer)').forEach((drawer) => {
          drawer.classList.remove('active', 'is-open', 'open');
          drawer.setAttribute('aria-hidden', 'true');
        });
      };
      const replaceDemeleDrawer = (cartState, sectionId) => {
        const current = getDemeleDrawer();
        const html = sectionId ? cartState.sections?.[sectionId] : '';
        if (!current || !html) return current;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector(demeleDrawerSelector);
        if (!fresh) return current;
        current.replaceWith(document.importNode(fresh, true));
        return getDemeleDrawer();
      };
      const openDemeleDrawer = (cartState, sectionId, trigger) => {
        closeThemeDrawer();
        const drawer = replaceDemeleDrawer(cartState, sectionId) || getDemeleDrawer();
        if (!drawer) {
          throw new Error('Le drawer Démélé est introuvable. Ajoutez data-dmle-cart-drawer à son conteneur principal.');
        }

        document.body.classList.add('dmpdp-use-demele-cart');
        document.dispatchEvent(new CustomEvent('demele:cart:refresh', { detail: cartState }));
        drawer.setActiveElement?.(trigger || document.activeElement);
        drawer.open?.(trigger);
        window.requestAnimationFrame(() => {
          drawer.classList.add('is-open', 'active', 'open');
          drawer.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('dmle-cart-is-open');
          document.body.classList.add('dmle-cart-is-open');
          document.dispatchEvent(new CustomEvent('demele:cart:open', { detail: cartState }));
        });
      };

      if (getDemeleDrawer()) document.body.classList.add('dmpdp-use-demele-cart');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!form.reportValidity() || form.dataset.masterSubmitting === 'true') return;

        const isMainForm = form.hasAttribute('data-master-form');
        const submitButton = form.querySelector('button[type="submit"]');
        const submitLabel = submitButton?.querySelector('span');
        const initialLabel = submitLabel?.textContent || '';
        const initialButtonHTML = submitButton?.innerHTML || '';
        const message = form.querySelector('[data-master-form-message]');
        const stickyButton = isMainForm ? root.querySelector('[data-master-sticky-button]') : null;
        const initialStickyLabel = stickyButton?.textContent || '';

        form.dataset.masterSubmitting = 'true';
        submitButton?.setAttribute('aria-disabled', 'true');
        submitButton?.classList.add('is-loading');
        if (submitLabel) submitLabel.textContent = 'Ajout en cours…';
        else if (submitButton) submitButton.textContent = 'Ajout en cours…';
        if (stickyButton) {
          stickyButton.disabled = true;
          stickyButton.textContent = 'Ajout en cours…';
        }
        if (message) {
          message.hidden = true;
          message.textContent = '';
        }

        try {
          const formData = new FormData(form);
          const demleDrawer = getDemeleDrawer();
          const drawerSectionId = getDrawerSectionId(demleDrawer);
          if (drawerSectionId) {
            formData.set('sections', `${drawerSectionId},cart-icon-bubble`);
            formData.set('sections_url', window.location.pathname);
          }

          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          });
          const cartState = await response.json();

          if (!response.ok || cartState.status) {
            throw new Error(cartState.description || cartState.message || 'Impossible d’ajouter ce produit au panier.');
          }

          openDemeleDrawer(cartState, drawerSectionId, submitButton);

          if (submitLabel) submitLabel.textContent = 'Ajouté';
          else if (submitButton) submitButton.textContent = 'Ajouté';
          if (stickyButton) stickyButton.textContent = 'Ajouté';
        } catch (error) {
          if (message) {
            message.textContent = error.message || 'Une erreur est survenue. Veuillez réessayer.';
            message.hidden = false;
          }
          if (submitLabel) submitLabel.textContent = initialLabel;
          else if (submitButton) submitButton.innerHTML = initialButtonHTML;
          if (stickyButton) stickyButton.textContent = initialStickyLabel;
        } finally {
          form.dataset.masterSubmitting = 'false';
          submitButton?.removeAttribute('aria-disabled');
          submitButton?.classList.remove('is-loading');
          if (stickyButton) stickyButton.disabled = false;
          window.setTimeout(() => {
            if (submitLabel) submitLabel.textContent = initialLabel;
            else if (submitButton) submitButton.innerHTML = initialButtonHTML;
            if (stickyButton) stickyButton.textContent = initialStickyLabel;
          }, 1200);
        }
      });
    });

    root.querySelectorAll('[data-ingredients-modal]').forEach((modal) => {
      const openButton = root.querySelector('[data-ingredients-open]');
      const closeButton = modal.querySelector('[data-ingredients-close]');
      if (!openButton || !closeButton) return;

      /* Le modal sort du conteneur produit afin que Safari mobile ne le
         positionne pas par rapport à un ancêtre transformé ou rogné. */
      if (modal.parentElement !== document.body) document.body.appendChild(modal);

      let opener = null;
      const close = () => {
        modal.hidden = true;
        document.body.classList.remove('dmpdp-modal-open');
        opener?.focus({ preventScroll: true });
      };
      const open = () => {
        opener = document.activeElement;
        modal.hidden = false;
        document.body.classList.add('dmpdp-modal-open');
        closeButton.focus({ preventScroll: true });
      };

      openButton.addEventListener('click', open);
      closeButton.addEventListener('click', close);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) close();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) close();
      });
    });

    root.querySelectorAll('.dmpdp__hero-details,.dmpdp__faq').forEach((group) => {
      group.querySelectorAll(':scope > details').forEach((details) => details.addEventListener('toggle', () => {
        if (!details.open) return;
        group.querySelectorAll(':scope > details[open]').forEach((other) => {
          if (other !== details) other.open = false;
        });
      }));
    });

    root.querySelectorAll('[data-before-after]').forEach((wrap) => {
      const range = wrap.querySelector('[data-before-after-range]');
      const layer = wrap.querySelector('[data-after-layer]');
      range?.addEventListener('input', () => { layer.style.width = `${range.value}%`; });
    });

    root.querySelectorAll('[data-copy-target]').forEach((button) => button.addEventListener('click', async () => {
      const copy = document.getElementById(button.dataset.copyTarget)?.textContent || '';
      try { await navigator.clipboard.writeText(copy); button.textContent = 'Liste copiée'; }
      catch (error) { button.textContent = 'Copie impossible'; }
    }));

    root.querySelectorAll('.dmpdp__usage-media video').forEach((video) => {
      video.autoplay = true;
      video.loop = true;
      video.muted = true;
      video.defaultMuted = true;
      video.controls = false;
      video.playsInline = true;
      video.disablePictureInPicture = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('controlslist', 'nodownload noplaybackrate nofullscreen');
      video.removeAttribute('controls');

      const keepPlaying = () => {
        if (!document.hidden && video.paused) video.play().catch(() => {});
      };
      video.addEventListener('pause', keepPlaying);
      video.addEventListener('ended', keepPlaying);
      document.addEventListener('visibilitychange', keepPlaying);
      keepPlaying();
    });

    root.querySelectorAll('[data-advisor]').forEach((advisor) => {
      const start = advisor.querySelector('[data-advisor-start]');
      const form = advisor.querySelector('[data-advisor-form]');
      const result = advisor.querySelector('[data-advisor-result]');
      start?.addEventListener('click', () => {
        start.hidden = true;
        form.hidden = false;
        form.querySelector('select')?.focus();
      });
      form?.addEventListener('submit', (event) => {
        event.preventDefault();
        const data = new FormData(form);
        const sensitive = data.get('scalp') === 'sensitive';
        const oily = data.get('scalp') === 'oily';
        const colored = data.get('treated') === 'colored';
        const answer = sensitive
          ? 'Ce produit n’est pas recommandé sur un cuir chevelu irrité ou très sensible. Attendez le retour au confort et demandez conseil à un professionnel de santé si l’inconfort persiste.'
          : `Oui, probablement. ${oily ? 'Comme vos racines regraissent vite, ' : ''}utilisez une à deux noisettes uniquement sur le cuir chevelu mouillé, une fois par semaine avant le shampooing.${colored ? ' Vos cheveux étant colorés, évitez de travailler le produit sur les longueurs.' : ''}`;
        form.hidden = true;
        result.hidden = false;
        result.innerHTML = `<small>Votre conseil personnalisé</small><p>${answer}</p><button type="button">Modifier mes réponses</button>`;
        result.querySelector('button')?.addEventListener('click', () => { result.hidden = true; form.hidden = false; });
      });
    });

    const counters = [...root.querySelectorAll('[data-proof-value]')];
    let counted = false;
    const animate = () => {
      if (counted) return;
      counted = true;
      counters.forEach((el, index) => {
        const raw = String(el.dataset.proofValue || '').replace(',', '.');
        const target = Number(raw);
        if (!Number.isFinite(target)) return;
        const start = performance.now() + index * 100;
        const tick = (now) => {
          const progress = Math.min(1, Math.max(0, (now - start) / 1100));
          el.textContent = Math.round(target * (1 - Math.pow(1 - progress, 4)));
          if (progress < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    };

    const revealObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      if (entry.target.classList.contains('dmpdp__chapter--proof')) animate();
    }), { threshold: 0.14 });
    root.querySelectorAll('[data-reveal]').forEach((el) => revealObserver.observe(el));

    const productNav = root.querySelector('.dmpdp__nav');
    const siteHeader = document.querySelector('[data-dmle-h10]');
    if (productNav && siteHeader) {
      const keepHeaderVisible = () => {
        siteHeader.classList.remove('dmle-h10--hidden');
        /* Important: ne jamais forcer transform sur le header.
           Un ancetre transforme devient le repere des descendants position:fixed
           et peut donc casser le drawer mobile du header sur la PDP. */
        siteHeader.style.removeProperty('transform');
        const headerRect = siteHeader.getBoundingClientRect();
        const headerHeight = Math.max(headerRect.height || 0, headerRect.bottom || 0, 54);
        root.style.setProperty('--dmpdp-site-header', `${Math.round(headerHeight)}px`);
      };
      const setPageOffset = () => {
        root.style.setProperty('--dmpdp-top-offset', '14px');
      };
      keepHeaderVisible();
      setPageOffset();
      document.body.classList.add('dmpdp-page-active');
      requestAnimationFrame(keepHeaderVisible);
      window.addEventListener('load', keepHeaderVisible, { once: true });
      window.addEventListener('scroll', keepHeaderVisible, { passive: true });
      window.addEventListener('resize', () => {
        keepHeaderVisible();
        requestAnimationFrame(setPageOffset);
      }, { passive: true });
    }

    /* Le sommaire reflète l'ordre éditorial réel, tient compte des deux barres
       fixes et garde son entrée active visible sur tablette et mobile. */
    if (productNav) {
      const navLinks = [...productNav.querySelectorAll('a[href^="#"]')];
      let navTargets = [];
      let activeNavId = '';
      let navFrame = 0;

      const resolveNavTarget = (link) => {
        const id = link.getAttribute('href')?.slice(1) || '';
        let target = id ? document.getElementById(id) : null;
        /* Judge.me place son ancre au coeur du widget. Pour le menu produit,
           on vise le début de toute la section afin de conserver son titre. */
        if (target && link.hasAttribute('data-dmpdp-reviews-link')) {
          target = target.closest('.dmjm') || target;
        }
        return { link, id, target };
      };

      const refreshNavTargets = () => {
        navTargets = navLinks.map(resolveNavTarget).filter(({ link, target }) => {
          link.hidden = !target;
          return Boolean(target);
        });
      };

      const getHeaderHeight = () => {
        const cssHeight = Number.parseFloat(getComputedStyle(root).getPropertyValue('--dmpdp-site-header'));
        if (Number.isFinite(cssHeight) && cssHeight > 0) return cssHeight;
        const header = siteHeader || document.querySelector('sticky-header, .header-wrapper, #shopify-section-header');
        if (!header) return 0;
        const rect = header.getBoundingClientRect();
        return Math.max(0, Math.min(rect.height || 0, rect.bottom || rect.height || 0));
      };

      const getScrollOffset = () => getHeaderHeight() + productNav.getBoundingClientRect().height + 14;

      const scrollToNavTarget = (item, updateHash = true) => {
        if (!item?.target) return;
        const top = item.target.getBoundingClientRect().top + window.scrollY - getScrollOffset();
        window.scrollTo({
          top: Math.max(0, Math.round(top)),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        if (updateHash && item.id && window.history?.replaceState) {
          window.history.replaceState(null, '', `#${item.id}`);
        }
      };

      const setActiveNav = (id) => {
        if (id === activeNavId) return;
        activeNavId = id;
        navTargets.forEach(({ link, id: linkId }) => {
          const isActive = linkId === id;
          link.classList.toggle('is-active', isActive);
          if (isActive) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        const activeLink = navTargets.find((item) => item.id === id)?.link;
        if (activeLink && productNav.scrollWidth > productNav.clientWidth) {
          productNav.scrollTo({
            left: Math.max(0, activeLink.offsetLeft - (productNav.clientWidth - activeLink.offsetWidth) / 2),
            behavior: 'smooth'
          });
        }
      };

      const updateActiveNav = () => {
        navFrame = 0;
        const marker = window.scrollY + getScrollOffset() + 10;
        let current = '';
        navTargets.forEach(({ id, target }) => {
          const targetTop = target.getBoundingClientRect().top + window.scrollY;
          if (targetTop <= marker) current = id;
        });
        setActiveNav(current);
      };
      const requestNavUpdate = () => {
        if (navFrame) return;
        navFrame = window.requestAnimationFrame(updateActiveNav);
      };
      window.addEventListener('scroll', requestNavUpdate, { passive: true });
      window.addEventListener('resize', () => {
        refreshNavTargets();
        requestNavUpdate();
      }, { passive: true });
      navLinks.forEach((link) => link.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const item = resolveNavTarget(link);
        if (!item.target) return;
        event.preventDefault();
        setActiveNav(item.id);
        scrollToNavTarget(item);
      }));

      refreshNavTargets();
      requestNavUpdate();
      /* Les widgets d'avis peuvent terminer leur initialisation après le DOM. */
      window.setTimeout(() => {
        refreshNavTargets();
        requestNavUpdate();
      }, 800);

      /* Corrige également une arrivée directe depuis une URL avec ancre. */
      window.addEventListener('load', () => {
        const hash = window.location.hash.slice(1);
        if (!hash) return;
        refreshNavTargets();
        const item = navTargets.find(({ id }) => id === hash);
        if (item) window.requestAnimationFrame(() => scrollToNavTarget(item, false));
      }, { once: true });
    }

    root.querySelectorAll('[data-result-gallery]').forEach((gallery) => {
      const modal = gallery.querySelector('[data-result-modal]');
      const beforeImage = gallery.querySelector('[data-result-before]');
      const afterImage = gallery.querySelector('[data-result-after]');
      const caption = gallery.querySelector('[data-result-caption]');
      const closeButton = gallery.querySelector('[data-result-close]');
      if (!modal || !beforeImage || !afterImage) return;
      /* Sortir la visionneuse des conteneurs animés évite que Safari masque
         le bouton de fermeture ou limite le plein écran. */
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      let opener = null;
      const close = () => {
        modal.hidden = true;
        document.body.classList.remove('dmpdp-modal-open');
        opener?.focus({ preventScroll: true });
      };
      const open = (button) => {
        opener = button;
        beforeImage.src = button.dataset.beforeSrc || '';
        afterImage.src = button.dataset.afterSrc || '';
        if (caption) {
          caption.textContent = button.dataset.caption || '';
          caption.hidden = !caption.textContent;
        }
        modal.hidden = false;
        document.body.classList.add('dmpdp-modal-open');
        closeButton?.focus({ preventScroll: true });
      };
      gallery.querySelectorAll('[data-result-open]').forEach((button) => button.addEventListener('click', () => open(button)));
      closeButton?.addEventListener('click', close);
      modal.querySelectorAll('img').forEach((image) => image.addEventListener('click', close));
      modal.addEventListener('click', (event) => { if (event.target === modal) close(); });
      document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !modal.hidden) close(); });
    });

    const sticky = root.querySelector('[data-master-sticky]');
    const stickyButton = root.querySelector('[data-master-sticky-button]');
    const mainForm = root.querySelector('[data-master-form]');
    const mainButton = mainForm?.querySelector('button[type="submit"]');
    if (sticky && mainButton) {
      const observer = new IntersectionObserver((entries) => {
        const entry = entries[0];
        const headerOffset = Number.parseFloat(getComputedStyle(root).getPropertyValue('--dmpdp-site-header')) || 0;
        const hasPassedButton = entry.boundingClientRect.bottom <= headerOffset;
        sticky.classList.toggle('is-visible', !entry.isIntersecting && hasPassedButton);
      }, { threshold: 0.01 });
      observer.observe(mainButton);
    }
    stickyButton?.addEventListener('click', () => {
      if (!mainForm || !mainButton || mainButton.disabled || mainForm.dataset.masterSubmitting === 'true') return;
      mainForm.requestSubmit(mainButton);
    });
  });
})();
